export const StoreLangTextA: any = {
    us: {
        store: 'Store',
    },
    cn: {
        store: '商城',
    },
    it: {
        store: 'negozio',
    },
    // de: {
    //     store: 'Geschäft',
    // },
    fr: {
        store: 'magasin',
    },
    es: {
        store: 'tienda',
    },
    kr: {
        store: '스토어',
    },
    jp: {
        store: 'ストア',
    },
    sa: {
        store: 'متجر',
    },
    br: {
        store: 'loja',
    },
    mx: {
        store: 'Tienda',
    },
    nl: {
        store: 'Winkel',
    },
};
